module.exports = __webpack_public_path__ + "img/mobile-home.9cabb1a1.png";